import React, { useEffect, useState } from 'react';
import { MTable } from 'ui/mtable/MTable';
import ConfirmationDialog from 'ui/dialog/ConfirmationDialog';
import UserInfo from 'ui/user/UserInfo';
import Dashboard from 'ui/dashboard/Dashboard';
import DashboardBox from 'ui/dashboard/Box';
import DashboardBoxContent from 'ui/dashboard/BoxContent';
import formatters from '../../../formatters';
import { loadDevices, removeDevices } from '../Services';
import DevicesImg from '../../../images/devices-165x165.png';
import { Typography, Grid } from '@material-ui/core';

import { withCompanyContext } from '../CompanyContext';

const getColumns = () => {
    return [
        {
            field: 'uuid',
            hidden: true,
        },
        {
            field: 'user_data',
            hidden: true,
        },
        {
            field: 'user',
            title: 'User',
            defaultSort: 'asc',
            filteredBy: 'user_data.full_data',
            render: rowData => <UserInfo user={rowData.user_data} />,
        },
        {
            field: 'name',
            title: 'Name',
        },
        {
            field: 'type',
            title: 'Type',
        },
        {
            field: 'app_version',
            title: 'App Version',
        },
        {
            field: 'last_sync',
            title: 'Last Sync',
            notFilter: true,
            render: rowData => formatters.date(rowData.last_sync),
        },
        {
            field: 'date_added',
            title: 'Date Added',
            notFilter: true,
            render: rowData => formatters.date(rowData.date_added),
        },
    ];
};

const dataMapping = data => {
    if (!data || !Array.isArray(data)) {
        return [];
    }
    return data.map(item => ({
        uuid: item.uuid,
        user_data: {
            ...item.account,
            full_data: `${item.account.first_name} ${item.account.last_name} ${item.account.email}`,
        },
        user: item.account.email,
        name: item.nickname,
        type: item.installation.device_type.name,
        app_version: item.software_version,
        last_sync: item.last_sync_date,
        date_added: item.created_date,
    }));
};

const DevicesView = ({ company, onMessage, editable }) => {
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);

    const selectedActions = [
        {
            key: 'delete',
            name: 'Delete devices',
            onClick: async dropdownCloseCallback => {
                setOpenDialog(true);
                dropdownCloseCallback();
            },
        },
    ];

    const fetchDevices = async () => {
        const devices = await loadDevices(company.id);
        const mappedData = dataMapping(devices);
        setData(mappedData);
        setLoading(false);
        setLoaded(true);
    };

    useEffect(() => {
        fetchDevices();
    }, []);

    const handleDeleteDevices = async () => {
        const uuids = selected.map(({ uuid }) => ({ uuid }));
        setLoading(true);
        setOpenDialog(false);
        onMessage('Device(s) will be deleted.', { variant: 'info' });
        await removeDevices(company.id, uuids);
        await fetchDevices();
    };

    const showTable = data.length > 0 || (data.length <= 0 && !loaded);

    return (
        <>
            <ConfirmationDialog
                open={openDialog}
                title="Delete device(s)"
                subtitle1="Delete selected devices? This process cannot be reversed."
                warning="Are you sure you want to delete:"
                data={selected.map(item => `${item.user} <${item.name}>`)}
                onCancel={() => setOpenDialog(false)}
                onOk={handleDeleteDevices}
            />
            {showTable && (
                <MTable
                    stateKey="Devices"
                    columns={getColumns()}
                    data={data}
                    loading={loading}
                    title={null}
                    actionMenuItems={selectedActions}
                    onSelectionChange={val => setSelected(val)}
                    options={{
                        selection: editable,
                    }}
                />
            )}
            {loaded && data.length <= 0 && (
                <Dashboard width="70" align="center">
                    <DashboardBox>
                        <DashboardBoxContent>
                            <Grid container spacing={3} direction="row">
                                <Grid item xs="auto">
                                    <img src={DevicesImg} alt="devices" />
                                </Grid>
                                <Grid item xs>
                                    <Grid
                                        container
                                        justifyContent="center"
                                        direction="column"
                                        style={{ height: '100%' }}
                                    >
                                        <Typography variant="h5" gutterBottom>
                                            Each device users have used to
                                            access their CyberFOX Password
                                            Manager account will appear here
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </DashboardBoxContent>
                    </DashboardBox>
                </Dashboard>
            )}
        </>
    );
};

export default withCompanyContext(DevicesView);
